class CoursesGrid {
  constructor () {
    this.gridList = document.querySelector('.js-course-grid-list')
    this.gridItemsNodeList = document.querySelectorAll('.js-course-grid-list-item')
    this.gridItems = Array.from(this.gridItemsNodeList)
    this.areasInputs = document.querySelectorAll('.js-course-grid-area-filter-input')
    this.gradesInputs = document.querySelectorAll('.js-course-grid-grade-filter-input')
    this.terms = {
      areas: [],
      grades: []
    }

    if (!this.gridItems.length && !this.terms.areas && !this.terms.grades) return

    this.init()
  }

  init () {
    const areasInputs = this.areasInputs
    const gradesInputs = this.gradesInputs
    const terms = this.terms
    const filters = document.querySelector('.c-coursesGrid__filters')
    const filtersButton = document.querySelector('.c-coursesGrid__button')
    const areas = document.querySelector('.c-coursesGrid__filterAreas')
    const areasButton = document.querySelector('.c-coursesGrid__filterAreasButton')
    const grades = document.querySelector('.c-coursesGrid__filterGrades')
    const gradesButton = document.querySelector('.c-coursesGrid__filterGradesButton')
    const filterItems = this.filterItems.bind(this)

    if (!filters && !filtersButton) return
    filtersButton.addEventListener('click', (e) => {
      filters.classList.toggle('isOpen')
      areas.classList.remove('isOpen')
      grades.classList.remove('isOpen')
    })

    if (!areas && !areasButton) return
    areasButton.addEventListener('click', (e) => {
      areas.classList.toggle('isOpen')
    })

    if (!grades && !gradesButton) return
    gradesButton.addEventListener('click', (e) => {
      grades.classList.toggle('isOpen')
    })

    if (!areasInputs.length) return
    areasInputs.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (!item.checked) {
          terms.areas.splice(terms.areas.indexOf(item.dataset.id), 1)
        } else {
          terms.areas.push(item.dataset.id)
        }
        filterItems(terms)
      }, false)
    })

    if (!gradesInputs.length) return
    gradesInputs.forEach((item) => {
      item.addEventListener('click', (e) => {
        if (!item.checked) {
          terms.grades.splice(terms.grades.indexOf(item.dataset.id), 1)
        } else {
          terms.grades.push(item.dataset.id)
        }
        filterItems(terms)
      }, false)
    })
  }

  filterItems (terms) {
    const gridList = this.gridList
    const gridItems = this.gridItems

    const result = gridItems.filter((item) => {
      if (terms.areas.length && !terms.areas.includes(item.dataset.area)) {
        return false
      }

      if (terms.grades.length && !terms.grades.includes(item.dataset.grade)) {
        return false
      }

      return true
    })

    gridList.innerHTML = ''

    if (result.length) {
      result.forEach(element => {
        gridList.appendChild(element)
      })
    } else {
      gridList.innerHTML = '<li class="c-coursesGrid__item">No results found</li>' // ToDo: translate
    }
  }
}

export default CoursesGrid
